import { useEffect, useState } from 'react';
import { useOfflineQueue } from '../lib/offline';
import { applyUpdate, hasUpdate, onPwaChange } from '../lib/pwa';
import { useUi } from '../state/ui';
import { Btn } from './ui';

/** Pruh nad obsahem: offline stav, čekající akce ve frontě, konflikty a nová verze aplikace. */
export function OfflineBanner() {
  const q = useOfflineQueue();
  const { toast } = useUi();
  const [update, setUpdate] = useState(hasUpdate());
  useEffect(() => onPwaChange(() => setUpdate(hasUpdate())), []);
  if (q.online && !q.pending.length && !q.failed.length && !update) return null;
  return (
    <div className={`offline-banner ${q.online ? '' : 'off'}`.trim()} role="status">
      {!q.online && <span>Offline – pracuješ s posledními daty.</span>}
      {q.pending.length > 0 && (
        <span>
          {q.pending.length}{' '}
          {q.pending.length === 1
            ? 'akce čeká'
            : q.pending.length < 5
              ? 'akce čekají'
              : 'akcí čeká'}{' '}
          na odeslání
        </span>
      )}
      {q.failed.length > 0 && (
        <span className="bad">
          {q.failed.length} {q.failed.length === 1 ? 'akce selhala' : 'akcí selhalo'}:{' '}
          {q.failed[0]?.error}
        </span>
      )}
      {q.online && q.pending.length > 0 && (
        <Btn
          sm
          onClick={() =>
            q
              .replay()
              .then((r) => toast(`Odesláno ${r.sent}, selhalo ${r.failed}, čeká ${r.pending}`))
          }
        >
          Odeslat teď
        </Btn>
      )}
      {q.failed.length > 0 && (
        <>
          <Btn sm onClick={() => q.retryFailed()}>
            Zkusit znovu
          </Btn>
          <Btn
            sm
            onClick={() => {
              for (const a of q.failed) q.remove(a.id);
            }}
          >
            Zahodit
          </Btn>
        </>
      )}
      {update && (
        <Btn sm variant="primary" onClick={applyUpdate}>
          Nová verze – obnovit
        </Btn>
      )}
    </div>
  );
}
